import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  margin-top: 21px;
  padding: 22px;
  border-radius: 3px;
  border: ${({ theme }) => `solid 1px ${theme.borders.preferenceMenuLine}`};
  background-color: ${({ theme }) => theme.backgrounds.paleGrey};
`;
Wrapper.displayName = 'Wrapper';

export const Summary = styled.div`
  font-size: 13px;
  font-weight: 500;
  line-height: 1.38;
  text-align: center;
  color: ${({ theme }) => theme.textfield.text};
`;
Wrapper.displayName = 'Wrapper';

export const UpgradeLicense = styled.div`
  font-size: 13px;
  font-weight: 500;
  line-height: 1.38;
  text-align: center;
  color: ${colors.grey19};
`;
Wrapper.displayName = 'Wrapper';
